import * as React from 'react';
import styled from 'styled-components';
import * as Icon from '../../icons';

declare module '../Controls/hkt' {
    interface URIControlsToKind {
        'checkbox': CheckboxProps
    }
}


const Checkbox_ = styled.input.attrs(_ => ({
    type: 'checkbox',
}))`
    appearance: none;
    width: 100%;
    height: 100%;
    border-radius: 2px;
    background-color: #e8e8e8;
    cursor: pointer;
    margin: 0;

    &:not(:disabled):hover {
        border: 1px solid #d6d1d1;
    }

    &:checked:hover {
        background-color: #8794A3;
        border-color: transparent;
    }

    &:checked {
        background-color: #98a9bc;
    }

    &:not(:checked):disabled {
        background-color: #F2F3F4;
    }

    &:disabled {
        background-color: #C1CCD8;
        cursor: default;
    }
`;


const InnerCheckbox = styled.div`
    position: relative;
    width: 1em;
    height: 1em;
    line-height: 0;
    margin: auto 0;

    svg {
        transition: all .33s ease; 
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        fill: #fff;
        width: 60%;
        height: 60%;
    }

    & > ${Checkbox_}:checked + svg {
        opacity: 1;
    }

    & > ${Checkbox_}:disabled:checked + svg {
        fill: #E7EAEE;
    }
`;



type CheckboxProps = {
    /**
     * Уникальное имя для одного или группы чекбоксов. Можно использовать это имя для записи в глобальный стейт приложения
     */
    name: string,

    /**
     * Состояние по умолчанию (вкл./выкл.)
     */
    checked?: boolean,

    /**
     * значение чекбокса
     */
    value: string,

    /**
     * Обработчик, срабатывающий при изменении состояния
     */
    onChange: (value: { [key: string]: boolean }, name: string, e: React.ChangeEvent<HTMLInputElement>) => void,

    /**
     * Активное(true) или неактивное(false) состояние
     */
    disabled?: boolean,

    className?: string,
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({ 
    name,
    value,
    checked, 
    onChange = () => {},
    disabled = false,
    className,
}, ref) => {
    
    const onChangeSelf = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;

        onChange({ [value]: checked }, name, e);
    }

    return (
        <InnerCheckbox className={className}>
            <Checkbox_ 
                type="checkbox"
                value={value}
                defaultChecked={checked}
                onChange={onChangeSelf}
                disabled={disabled}
                ref={ref}
            />
            <Icon.Checked />
        </InnerCheckbox>
    );
});

export default Checkbox;
